module.exports = __webpack_public_path__ + "img/村村团-太阳码.181170f6.jpg";